import React, { Suspense, useState, useRef } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import DeleteIcon from "@mui/icons-material/Delete"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import { Canvas } from "@react-three/fiber";
import { View } from "@react-three/drei";

import { getStripeCheckoutURL } from "../api";
import { projectStyle, hiddenCanvas } from "../styleFile.js";

import { ScreenshotForProjectsPage } from "../components/Screenshot";

import { useObjectStore } from "../zustand/objects";

import { useAccountStore } from "../zustand/account";
import { Card, Button, Text, ActionIcon, Tooltip } from '@mantine/core';


export default function ProjectsTable({ projects, isGuest, handleCopySubmit }) {

    const { getSpecificUserProject, unloadObjects, objectsAreLoaded } = useObjectStore();
    const { updateDeleteModalOpen, updateDeleteID, createNewProject, userStatus } = useAccountStore();

    // Retrieve project data by url's query string (projectKey) and set to zustand project state
    const setProjectState = (projectKey) => {
        getSpecificUserProject(projectKey)
    }

    // Send projectKey to delete function and open delete modal
    const handleDeleteClick = (id) => {
        updateDeleteID(id)
        updateDeleteModalOpen()
    }

    // Wipe any object state and get new project data
    const onEditClick = (e) => {
        unloadObjects()
        setProjectState(e)
    }

    // As this page is for login redirection, this handles sucessful or failed subscription logins
    const handleSubscriptionClick = (label) => {
        getStripeCheckoutURL({
            success_url: 'https://mbxr.io/projects',
            cancel_url: 'https://mbxr.io/logging-out',
            // success_url: 'http://localhost:3000/projects',
            // cancel_url: 'http://localhost:3000/membership',
            subscription: label
        })
            .then((res) => window.location.replace(res.url))
    }

    const canvasRef = useRef()

    return (<div>
        <Suspense fallback={null}>
            <CssBaseline />
            <Suspense fallback={<div>Loading... </div>}>
                <Box>
                    <Container component="form" style={projectStyle.container.slimFormContainer}>
                        <Grid sx={{ marginTop: 0 }} container id="container">
                            {projects && projects.map((row, i) => (
                                row && objectsAreLoaded && <Suspense fallback={<img src="/image/loading.gif" style={projectStyle.loadingSpinnerContainer} />} key={i}>
                                    <Grid item key={i} xs={12} sm={6} md={3}>
                                        <Card radius={16} p={0} m={10}
                                            shadow="0px 1px 3px 0px rgba(0, 0, 0, 0.05), 0px 1px 2px 0px rgba(0, 0, 0, 0.10)">
                                            <Box style={projectStyle.box.projectScreenshotBox}>
                                                <Suspense fallback={<img src="/image/loading.gif" style={{ width: "50px", height: "50px" }} />}>
                                                    {objectsAreLoaded && <ScreenshotForProjectsPage index={i} floorColour={row.floorColour} artboard={row.artboards[1]} />}
                                                </Suspense>
                                            </Box>
                                            <Box>
                                                <Box style={projectStyle.box.projectTextBox}>
                                                    <Text size={'sm'} fw={600}>
                                                        {row.projectName}
                                                    </Text>
                                                </Box>
                                                <Box style={projectStyle.box.projectTextBox}>
                                                    <Text size={'sm'} fw={400}>
                                                        {new Date(row.created_at).toDateString()}
                                                    </Text>
                                                </Box>
                                            </Box>
                                            <Grid container>
                                                <Grid item xs={8}>
                                                    {(!isGuest && userStatus === 'loggedIn-none' || userStatus === 'loggedIn-canceled') && i !== 0 ?
                                                        <Button onClick={() => handleSubscriptionClick("pioneer")} style={projectStyle.projectButton.upgradePlaceholderButton} ml={10}>
                                                            Upgrade</Button >
                                                        :
                                                        <Button
                                                            style={projectStyle.projectButton.editProjectButton}
                                                            onClick={() => { onEditClick(row.projectKey) }}
                                                            component='a'
                                                            href={`/editor/${row.projectKey}`}>
                                                            Edit
                                                        </Button>}
                                                </Grid>
                                                <Grid item xs={2}>
                                                    {!isGuest && <Tooltip label="Delete project">
                                                        <ActionIcon
                                                            variant='transparent'
                                                            color='black'

                                                            onClick={(e) => {
                                                                e.preventDefault()
                                                                handleDeleteClick(row.projectKey)
                                                            }}>
                                                            <DeleteIcon />
                                                        </ActionIcon></Tooltip>}
                                                </Grid>
                                                <Grid item xs={2}>
                                                    <Tooltip label="Duplicate project"><ActionIcon
                                                        variant='transparent'
                                                        color='black'

                                                        onClick={(e) => {
                                                            e.preventDefault()
                                                            handleCopySubmit(row.projectKey)
                                                        }}>
                                                        <ContentCopyIcon />
                                                    </ActionIcon></Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Card>
                                    </Grid></Suspense>
                            ))}
                        </Grid>
                    </Container>
                </Box>
            </Suspense>
        </Suspense>
        <Canvas
            eventSource={document.getElementById("root")}
            className="canvas"
            shadows
            style={hiddenCanvas}
            camera={{
                position: [0, 0, 0],
                fov: 55
            }}
            frameloop="demand"
            gl={{ preserveDrawingBuffer: true }}
            ref={canvasRef}
        >
            <View.Port />
        </Canvas>
    </div>
    );
}



